import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { getSalaryFormatOptions } from '@/helpers/salary-utils';

import { SalaryValid } from '../../types';
import { SalaryForecastBar } from '../salary-forecast-bar';
import { SalaryProvidedHeader } from '../salary-provided-header';

import { BodyCopy } from '../salary-module.common.styles';

type Props = {
  salary: SalaryValid;
};

export const SalaryExact: React.VFC<Props> = ({ salary }) => {
  const { formatMessage, formatNumber } = useIntl();

  return (
    <>
      <SalaryProvidedHeader headlineCopy={formatMessage({ id: 'JOBS_DETAIL_SALARY_EXACT_HEADLINE' })} />
      <BodyCopy>
        <FormattedMessage id="JOBS_DETAIL_SALARY_EXACT_BODY" />
      </BodyCopy>
      <SalaryForecastBar headlineCopy={formatNumber(salary.amount, getSalaryFormatOptions(salary.currency))} />
    </>
  );
};
